import Tippy from '@tippyjs/react';
import { FormikProvider, useFormik } from 'formik';
import { FC, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppParams } from '../../../hooks/useAppParams';
import { useEmptyAccountPage } from '../../../hooks/useEmptyAccountPage';
import { SearchFormBase } from '../../SearchFormBase';
import { emptyAccountPageHandlers, IFormValues, PageActions, submitObj } from './handlers';

export const Search: FC<{ className: string }> = ({ className }) => {
  const history = useHistory();
  const params = useAppParams();
  const location = useLocation();
  const [activeCondition, setActiveCondition] = useState<PageActions | null>();
  const { isEmptyAccountPage } = useEmptyAccountPage();

  const formik = useFormik<IFormValues>({
    initialValues: {
      search: '',
    },
    onSubmit: (values) => {
      activeCondition?.callback(history, params)(values);
    },
  });

  useEffect(() => {
    if (!location.search) {
      const result = submitObj.find((item) => item.regExp.test(location.pathname));
      setActiveCondition(result ?? null);
    } else {
      setActiveCondition(isEmptyAccountPage ? emptyAccountPageHandlers : null);
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    formik.resetForm();
  }, [activeCondition?.placeholder]);

  if (!activeCondition) return null;

  return (
    <FormikProvider value={formik}>
      <Tippy
        content='Enter account ID'
        visible={isEmptyAccountPage}
        className='big-font'
        placement='bottom-start'
      >
        <SearchFormBase
          onResetInputSearch={activeCondition.resetCallback(formik, history)}
          onSubmit={formik.handleSubmit}
          fieldName='search'
          className={className}
          placeholder={activeCondition.placeholder}
          autofocus={isEmptyAccountPage}
        />
      </Tippy>
    </FormikProvider>
  );
};
